import httpClient from './api/httpClient';

const END_POINT = 'endereco';
export const getOne = () => httpClient.get(END_POINT + '/');
export const create = (endereco) => {
    return httpClient.post(END_POINT, endereco);
}